import React from 'react';

import { SecondaryButton } from '@components/Button/variants';
import CustomSpinner, { CustomSpinnerColor } from '@components/Spinner/CustomSpinner';
import useAiThreads from '@hooks/useAiThreads';
import { deep_research_path } from '@routes';

import AiThreadItem from './AiThreadItem';

const perPage = 20;

const AiThreads = (): JSX.Element => {
  const { aiThreads, isLoadingAiThreads, hasNextPage, fetchNextPage, isFetchingNextPage } =
    useAiThreads({ perPage });

  return (
    <div id="research-history" className="border-0 border-b border-solid" data-testid="ai-threads">
      <h2 className="mb-6 font-suisse-works text-headline-xxs">Research history</h2>
      <p className="mt-0 font-suisse-intl text-description-sm">
        Click on a topic to view the entire thread.
      </p>
      {isLoadingAiThreads ? (
        <CustomSpinner
          size={10}
          color={CustomSpinnerColor.PrimaryMagenta}
          style={{ padding: '20px 0px' }}
        />
      ) : (
        <div className="pb-24">
          {aiThreads.length > 0 ? (
            <>
              <ul className="list-none px-0 pt-6">
                {aiThreads.map((aiThread) => (
                  <AiThreadItem key={aiThread.id} aiThread={aiThread} />
                ))}
              </ul>
              {hasNextPage && (
                <div className="mb-24 pt-6 text-center">
                  <SecondaryButton
                    as="button"
                    onClick={() => fetchNextPage()}
                    disabled={isFetchingNextPage}
                    className="w-full border border-primary-magenta py-10 text-primary-magenta disabled:opacity-50"
                  >
                    {isFetchingNextPage ? 'Loading…' : 'Load more'}
                  </SecondaryButton>
                </div>
              )}{' '}
            </>
          ) : (
            <a className="text-body-md text-primary-magenta" href={deep_research_path()}>
              Ask your first Deep Research question
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default AiThreads;
